export const SALES_PERSON_RESULT_URL_PATH = 'salesperson/result';
export const REGULAR_PRODUCT_LIMIT = 5;
export const UPDATED_PRODUCT_LIMIT = 8;
export const QUERIES_LIMIT = 5;

export const SEARCH_PROVIDER_ALGOLIA = 'algolia';
